import apiClient from './apiClient';

export interface F117 {
  f117_01: string; f117_11: string; f117_12: boolean;
  f117_91: string; f117_92: string | null; f117_93: string;
}
export interface ListResponse { data: F117[]; total: number; page: number; size: number; }
export interface ValidationError { field: string; message: string; }

export const tradeTermsApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    return (await apiClient.get('/api/trade-terms', { params })).data;
  },
  async get(code: string): Promise<F117> {
    return (await apiClient.get(`/api/trade-terms/${encodeURIComponent(code)}`)).data;
  },
  async create(data: { f117_01: string; f117_11: string; f117_12: boolean }): Promise<F117> {
    return (await apiClient.post('/api/trade-terms', data)).data;
  },
  async update(code: string, data: { f117_11: string; f117_12: boolean }): Promise<F117> {
    return (await apiClient.put(`/api/trade-terms/${encodeURIComponent(code)}`, data)).data;
  },
  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/trade-terms/${encodeURIComponent(code)}`);
  },
};
